(() => {
  if (window.__jdcCartHapticsReady) return;
  window.__jdcCartHapticsReady = true;

  const addToCartSelector = [
    '[data-product-atc]',
    '[data-quick-buy]',
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] input[type="submit"]'
  ].join(',');

  const isMobileTouchDevice = () => {
    const coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const touchPoints = Number(navigator.maxTouchPoints || 0) > 0;
    return window.innerWidth <= 859 && (coarsePointer || touchPoints);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(addToCartSelector);
    if (!trigger || !isMobileTouchDevice()) return;
    if (trigger.disabled || trigger.classList.contains('disabled')) return;
    if (trigger.getAttribute('aria-disabled') === 'true') return;
    if (trigger.hasAttribute('data-quickshop-slim')) return;

    if (typeof navigator.vibrate === 'function') {
      navigator.vibrate(35);
    }
  }, { capture: true, passive: true });
})();
